import { render, staticRenderFns } from "./EntityActivityTable.vue?vue&type=template&id=5324aca8&"
import script from "./EntityActivityTable.vue?vue&type=script&lang=js&"
export * from "./EntityActivityTable.vue?vue&type=script&lang=js&"
import style0 from "./EntityActivityTable.vue?vue&type=style&index=0&id=5324aca8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports